















import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class DadosModelo extends Vue {

    get loadingModelos () {
        return this.$store.state.loading_modelos;
    }

    get listaModelos () {
        return this.$store.state.modelos;
    }

    get modelo () {
        return this.$store.state.cotacao.modelo;
    }

    set modelo ( value ) {
        this.$store.dispatch("SET_MODELO", value).then();
    }

    get errorModelo () {
        return this.$store.state.errors.modelo;
    }

    public onChange () {
        this.$store.dispatch("VALIDAR_DADOS")
            .then()
            .catch(() => { return; });
    }
}
